// src/context/AuthContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';

const AuthContext = createContext();
const SESSION_USER_STORAGE_KEY = 'authSessionUser';

const readStoredSessionUser = () => {
  const raw = localStorage.getItem(SESSION_USER_STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn('No se pudo leer authSessionUser desde localStorage:', error);
    localStorage.removeItem(SESSION_USER_STORAGE_KEY);
    return null;
  }
};

export const AuthProvider = ({ children }) => {
  const auth = getAuth();
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || null);
  const [sessionUser, setSessionUser] = useState(readStoredSessionUser);
  const [firebaseUser, setFirebaseUser] = useState(auth.currentUser);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setFirebaseUser(currentUser);
    });

    return unsubscribe;
  }, [auth]);

  useEffect(() => {
    if (userRole) {
      localStorage.setItem('userRole', userRole);
    } else {
      localStorage.removeItem('userRole');
    }
  }, [userRole]);

  useEffect(() => {
    if (sessionUser) {
      localStorage.setItem(SESSION_USER_STORAGE_KEY, JSON.stringify(sessionUser));
    } else {
      localStorage.removeItem(SESSION_USER_STORAGE_KEY);
    }
  }, [sessionUser]);

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.warn('No se pudo cerrar la sesión de Firebase:', error);
    }
    setUserRole(null);
    setSessionUser(null);
    setFirebaseUser(null);
    localStorage.removeItem('userRole');
  };

  return (
    <AuthContext.Provider
      value={{ userRole, setUserRole, sessionUser, setSessionUser, firebaseUser, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
